// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__13t7U","ranges":"BmiRanges_ranges__2uU5y"};